import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/uczen')({
  component: () => <Outlet />,
})
